import React from 'react';

export default function JadwalInterview() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Jadwal Interview</h1>
      <p className="text-gray-500">Halaman Jadwal Interview</p>
    </div>
  );
}
